module.exports = __webpack_public_path__ + "img/footer_logo1.8b6c8b23.png";